import React, { useState, useEffect } from 'react';
import { LogIn, ShoppingCart, Building2, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Logo = () => (
  <div className="flex items-center gap-2">
    <img
      src="/images/logo_plus_site.webp"
      alt="PlusPlus"
      className="h-8 md:h-9 w-auto object-contain"
    />
  </div>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`fixed left-0 right-0 z-50 px-4 pt-4 transition-all ${scrolled ? 'pt-3' : ''}`} style={{ top: 'var(--pp-bar, 0px)' }}>
      <div className="max-w-6xl mx-auto">
        <nav className="bg-[#0f0f10] rounded-full border border-white/5 shadow-[0_10px_40px_-10px_rgba(0,0,0,0.4)] flex items-center justify-between px-5 py-3">
          <Link to="/" className="flex items-center">
            <Logo />
          </Link>

          <div className="hidden md:flex items-center gap-8 text-white/80">
            <a href="/#loja" className="hover:text-white transition-colors text-sm font-medium">Produtos</a>
            <Link to="/corporativo" className="hover:text-white transition-colors text-sm font-medium flex items-center gap-1.5"><Building2 className="w-4 h-4" />Para empresas</Link>
            <a href="/blog/" className="hover:text-white transition-colors text-sm font-medium">Blog</a>
            <a href="/#revendedor" className="hover:text-white transition-colors text-sm font-medium">Revendedor</a>
          </div>

          <div className="flex items-center gap-2">
            <a
              href="https://baseplus.com.br/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 bg-white text-[#0f0f10] px-3 sm:px-4 py-2 rounded-full text-sm font-semibold hover:bg-white/90 transition"
            >
              <LogIn className="w-4 h-4" />Entrar
            </a>
            <a
              href="/#loja"
              className="pp-btn-gradient inline-flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full text-sm font-semibold"
            >
              <ShoppingCart className="w-4 h-4" />
              <span className="hidden sm:inline">Escolher meu cartão</span>
              <span className="sm:hidden">Escolher</span>
            </a>
            <button className="md:hidden text-white p-1" onClick={() => setOpen(!open)} aria-label="menu">
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </nav>

        {open && (
          <div className="md:hidden mt-2 bg-[#0f0f10] rounded-2xl p-4 space-y-3 text-white/85">
            <a href="/#loja" onClick={() => setOpen(false)} className="block text-sm">Produtos</a>
            <Link to="/corporativo" onClick={() => setOpen(false)} className="block text-sm">Para empresas</Link>
            <a href="/blog/" onClick={() => setOpen(false)} className="block text-sm">Blog</a>
            <a href="/#revendedor" onClick={() => setOpen(false)} className="block text-sm">Revendedor</a>
            <a href="https://baseplus.com.br/" target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="block text-sm">Entrar</a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
